import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const HistorialPagos = () => {
  const { user } = useAuth();
  const [pagos, setPagos] = useState([]);

  useEffect(() => {
    const fetchPagos = async () => {
      try {
        const res = await axios.get(`https://www.fancyplus.digital/api/users/historialpagos/${user.id}`);
        setPagos(res.data);
      } catch (err) {
        console.error("Error al obtener historial de pagos:", err);
      }
    };

    if (user?.id) {
      fetchPagos();
    }
  }, [user]);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Historial de Pagos</h2>

      {pagos.length === 0 ? (
        <p className="text-gray-500">No hay pagos registrados aún.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white shadow-md rounded">
            <thead>
              <tr className="bg-gray-100 text-gray-700 text-sm">
                <th className="py-2 px-4 text-left">Fecha de Pago</th>
                <th className="py-2 px-4 text-left">Período</th>
                <th className="py-2 px-4 text-left">Inicio</th>
                <th className="py-2 px-4 text-left">Fin</th>
                <th className="py-2 px-4 text-left">Método</th>
                <th className="py-2 px-4 text-left">Monto</th>
                <th className="py-2 px-4 text-left">Estado</th>
              </tr>
            </thead>
            <tbody>
              {pagos.map((pago, idx) => (
                <tr key={idx} className="border-t text-sm">
                  <td className="py-2 px-4">{new Date(pago.fecha_pago).toLocaleDateString()}</td>
                  <td className="py-2 px-4 capitalize">{pago.subscription_period}</td>
                  <td className="py-2 px-4">{new Date(pago.fecha_inicio).toLocaleDateString()}</td>
                  <td className="py-2 px-4">{new Date(pago.fecha_fin).toLocaleDateString()}</td>
                  <td className="py-2 px-4 capitalize">{pago.metodo_pago}</td>
                  <td className="py-2 px-4">{pago.monto} {pago.moneda}</td>
                  <td className={`py-2 px-4 font-semibold ${
                    pago.estado === 'completado' ? 'text-green-600' :
                    pago.estado === 'pendiente' ? 'text-yellow-600' :
                    'text-red-600'
                  }`}>
                    {pago.estado}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default HistorialPagos;
